<template>
  <div class="video-box">
    <div class="video-title">
      <img class="video-title-img" src="../img/map.png" style=""  @click="changeTab">
      <div class="video-title-select">
        <div class="video-select" v-if="showFlg">
          设备名
          <el-select @change="videoChange($event)" v-model="videoDevice" filterable >
            <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in videoOption" >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
<!--    <div id="video-container" class="video-body" v-if="showFlg" ref="Temp"> 摄像头画面大小动态变化-->
    <div id="video-container" class="video-body" v-if="showFlg" ref="Temp">
    </div>
  </div>
</template>

<script>
  import EZUIKit from 'ezuikit-js'
  import axios from 'axios'
  import {getAttributesServer} from "../../until/api/MeteSoil";
  export default {
    name: 'VideoData',
    components: {
      EZUIKit,
      axios
    },
    data() {
      return {
        videoOption:[],
        videoDevice:'',
        videoAddress: [],
        appKey:'',
        secret: '',
        deviceSerial: '',
        accessToken: '',
        videoUrl: '',
        player: null,
        windowWidth: document.documentElement.clientWidth, //摄像头画面大小固定
        windowHeight: document.documentElement.clientHeight, //摄像头画面大小固定
        // tempWidth: 0, //摄像头画面大小动态变化
        // tempHeight: 0, //摄像头画面大小动态变化
        videoTime: '',
        showFlg: false,
        channelNo: 1,
      }
    },
    beforeDestroy() {
      clearInterval(this.videoTime);
      this.videoTime = null;
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;
      if(authority != 'TENANT_ADMIN') {
        this.getVideoJson(customerId)//获取用户服务端数据
      }

      //摄像头画面大小动态变化
      // this.tempWidth = this.windowWidth * 0.5;
      // this.tempHeight = this.windowHeight * 0.54;
      // let that = this;
      // window.onresize = () => {
      //   return (() => {
      //     that.tempWidth = this.$refs.Temp.offsetWidth - 20;
      //     that.tempHeight = this.$refs.Temp.offsetHeight;
      //     this.setPlayVideo();
      //   })()
      // }
    },

    methods: {
      /**
       * 获取用户服务端数据
       * @param customerId
       */
      getVideoJson(customerId) {
        let num = 0;
        this.videoOption = [];
        this.videoDevice = '';
        this.videoAddress = [];
        this.appKey = '';
        this.secret = '';
        this.deviceSerial = '';
        getAttributesServer('CUSTOMER', customerId).then(response => {
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].key.toString().indexOf('vedio') !== -1) {//筛选出摄像头设备
              let json = JSON.parse(response.data[i].value);
              let videoJson = {};
              videoJson.id = num;
              videoJson.name = json.deviceSerial;
              this.videoOption.push(videoJson);
              this.videoAddress.push(json);
              num++;
            }
          }
          this.videoOption.length == '' ? this.videoDevice = '' : this.videoDevice = this.videoOption[0].id;//初期化选中摄像头
          this.videoAddress.length == '' ? this.appKey = '' : this.appKey = this.videoAddress[0].appKey;//初期化选中摄像头的appkey
          this.videoAddress.length == '' ? this.secret = '' : this.secret = this.videoAddress[0].secret;//初期化选中摄像头的secret
          //this.videoAddress.length == '' ? this.deviceSerial = '' : this.deviceSerial = this.videoAddress[0].deviceSerial;//初期化选中摄像头的deviceSerial
          //初期化选中摄像头的deviceSerial
          if(this.videoAddress.length == '') {
            this.channelNo = 0;
            this.deviceSerial = '';
          } else {
            this.channelNo = 1;
            if(this.videoAddress[0].deviceSerial.indexOf('-') !== -1) {
              this.deviceSerial = this.videoAddress[0].deviceSerial.split("-")[0];
              this.channelNo = this.videoAddress[0].deviceSerial.split("-")[1];
            } else {
              this.deviceSerial = this.videoAddress[0].deviceSerial;
            }
          }
          this.setVideoShow();//获取播放地址并播放视频
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 切换摄像头
       * @param event
       */
      videoChange(event) {
        this.videoDevice = this.videoOption[event].id;//选中的摄像头
        this.appKey = this.videoAddress[event].appKey;//选中摄像头的appkey
        this.secret = this.videoAddress[event].secret;//选中摄像头的secret
        //this.deviceSerial = this.videoAddress[event].deviceSerial;
        let deviceNum = this.videoAddress[event].deviceSerial;//选中摄像头的deviceSerial
        this.channelNo = 1;
        if(deviceNum.indexOf('-') !== -1) {
          this.deviceSerial = deviceNum.split("-")[0];
          this.channelNo = deviceNum.split("-")[1];
        } else {
          this.deviceSerial = deviceNum;
        }
        this.setVideoShow();//获取播放地址并播放视频
      },

      /**
       * 获取播放地址并播放视频
       */
      setVideoShow() {
        this.showFlg = true;
        if(this.appKey !== '' && this.secret !== '' && this.deviceSerial !== '') {
          Promise.all([
            this.getAccessToken() //获取accesstoken
          ]).then(res => {
            Promise.all([
              this.getVideoUrl() // 获取播放url
            ]).then(res => {
              if(this.videoTime != null) { //清空上次摄像头播放时间
                clearInterval(this.videoTime);
                this.videoTime = null;
              }
              this.setPlayVideo();// 摄像头播放
              this.videoTime = window.setInterval(() => {//每隔十分钟重新播放一次摄像头
                setTimeout(() => {
                  this.setPlayVideo();// 摄像头播放
                },0)
              }, 1000 * 60 * 10)
            })
          })
        } else {
          this.showFlg = false;
          return;
        }
      },

      /**
       * 获取accessToken
       * @returns {Promise<AxiosResponse<any>>}
       */
      getAccessToken() {
        let url = '/api/lapp/token/get?appKey=' + this.appKey + '&appSecret=' + this.secret;
        return axios({
          method: 'post',
          baseURL:process.env.API,
          url,
          headers: {
            'Content-Type':'application/x-www-form-urlencoded'
          },
          timeout: 10000
        }).then(response => {
          this.accessToken = response.data.data.accessToken;
        })
      },

      /**
       * 获取播放url
       * @returns {Promise<AxiosResponse<any>>}
       */
      getVideoUrl() {
        let url = '/api/lapp/v2/live/address/get?accessToken=' + this.accessToken + '&deviceSerial=' + this.deviceSerial + '&channelNo=' + this.channelNo;
        return axios({
          method: 'post',
          baseURL: process.env.API,
          url,
          headers: {
            'Content-Type':'application/x-www-form-urlencoded'
          },
          timeout: 10000
        }).then(response => {
          if(response.data.msg == "操作成功") {
            this.videoUrl = response.data.data.url;
          } else {
            this.videoUrl = 'ezopen://open.ys7.com/' + this.deviceSerial + '/' + this.channelNo + '.hd.live';
          }

        }).catch(error => {
          this.videoUrl = 'ezopen://open.ys7.com/' + this.deviceSerial + '/1.hd.live';
          console.log("error", error);
        })
      },

      /**
       * 播放视频
       */
      setPlayVideo() {
        document.getElementById("video-container").innerHTML = "";
        this.player = null;
        if(this.channelNo == 1) {
          this.player = new EZUIKit.EZUIKitPlayer({
            autoplay: true,
            id: "video-container",
            accessToken: this.accessToken,
            url: this.videoUrl,
            template: 'theme',
            // width: this.tempWidth, //摄像头画面大小动态变化
            // height: this.tempHeight //摄像头画面大小动态变化
            width: this.windowWidth * 0.5, //摄像头画面大小固定
            height: this.windowHeight * 0.54 //摄像头画面大小固定
          })
        } else {
          this.player = new EZUIKit.EZUIKitPlayer({
            autoplay: true,
            id: "video-container",
            accessToken: this.accessToken,
            url: this.videoUrl,
            template: 'simple',
            // width: this.tempWidth, //摄像头画面大小动态变化
            // height: this.tempHeight //摄像头画面大小动态变化
            width: this.windowWidth * 0.5, //摄像头画面大小固定
            height: this.windowHeight * 0.54 //摄像头画面大小固定
          })
        }
      },

      //切换到地图画面
      changeTab(){
        this.$emit("showMapBar", true);
      },
    }
  }
</script>

<style lang="less" scoped>
  .video-box {
    width: 100%;
    height: 100%;

    .video-title {
      width: 100%;
      height: 10%;
      position:relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .video-title-img {
        height: 32px;
        height: 32px;
        cursor: pointer;
        padding-left: 7px;
        padding-top: 7px
      }

      .video-title-select {
        width: 31%;
        height: 100%;
        display: table;

        .video-select {
          display: table-cell;
          vertical-align: middle;
          color: #ffffff;
          font-size:18px;
        }
      }

    }

    .video-body {
      width: 98%;
      height:88%;
      left: 2%;
      position:relative;
      display: block !important;
    }

    /deep/ .el-input__inner {
      background-color: transparent;
      outline: none;
      //border: none;
      border-color: #09CEFF;
      color: #51b9fb;
      appearance: none;
      -webkit-appearance: none;
      font-size: 16px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/view/VideoData.vue